import { eventManagerTypes } from "../types/eventManagerTypes";

const initialState = {
    isFetchingEvents: false,
    isFetchedEventsSuccess: null,
    isFetchedEventsFailure: null,
    isFetchingOrganizers: false,
    isFetchedOrganizersSuccess: null,
    isFetchedOrganizersFailure: null,
    isFetchingSingleEvent: false,
    isFetchedSingleEventSuccess: null,
    isFetchedSingleEventFailure: null,
    isFetchingEventVendors: false,
    isFetchedEventVendorsSuccess: null,
    isFetchedEventVendorsFailure: null,
    isCreatingEvent: false,
    isCreatedEventSuccess: null,
    isCreatedEventFailure: null,
    isUpdatingEvent: false,
    isUpdatedEventSuccess: null,
    isUpdatedEventFailure: null,
    isPublishingEvent: false,
    isPublishedEventSuccess: null,
    isPublishedEventFailure: null,
    isUnpublishingEvent: false,
    isUnpublishedEventSuccess: null,
    isUnpublishedEventFailure: null,
};

export function eventManager(state = initialState, action: { type: string, payload: any }) {
    switch (action.type) {
        case eventManagerTypes.UPDATE_EVENT_REQUEST:
            return {
                ...state,
                isUpdatingEvent: true,
                isUpdatedEventSuccess: null,
                isUpdatedEventFailure: null,
            };
        case eventManagerTypes.UPDATE_EVENT_SUCCESS:
            return {
                ...state,
                isUpdatingEvent: false,
                isUpdatedEventSuccess: action.payload,
                isUpdatedEventFailure: null,
            };
        case eventManagerTypes.UPDATE_EVENT_FAILURE:
            return {
                ...state,
                isUpdatingEvent: false,
                isUpdatedEventSuccess: null,
                isUpdatedEventFailure: action.payload,
            };

        case eventManagerTypes.PUBLISH_EVENT_REQUEST:
            return {
                ...state,
                isPublishingEvent: true,
                isPublishedEventSuccess: null,
                isPublishedEventFailure: null,
            };
        case eventManagerTypes.PUBLISH_EVENT_SUCCESS:
            return {
                ...state,
                isPublishingEvent: false,
                isPublishedEventSuccess: action.payload,
                isPublishedEventFailure: null,
            };
        case eventManagerTypes.PUBLISH_EVENT_FAILURE:
            return {
                ...state,
                isPublishingEvent: false,
                isPublishedEventSuccess: null,
                isPublishedEventFailure: action.payload,
            };
        case eventManagerTypes.UNPUBLISH_EVENT_REQUEST:
            return {
                ...state,
                isUnpublishingEvent: true,
                isUnpublishedEventSuccess: null,
                isUnpublishedEventFailure: null,
            };
        case eventManagerTypes.UNPUBLISH_EVENT_SUCCESS:
            return {
                ...state,
                isUnpublishingEvent: false,
                isUnpublishedEventSuccess: action.payload,
                isUnpublishedEventFailure: null,
            };
        case eventManagerTypes.UNPUBLISH_EVENT_FAILURE:
            return {
                ...state,
                isUnpublishingEvent: false,
                isUnpublishedEventSuccess: null,
                isUnpublishedEventFailure: action.payload,
            };

        case eventManagerTypes.CREATE_EVENT_REQUEST:
            return {
                ...state,
                isCreatingEvent: true,
                isCreatedEventSuccess: null,
                isCreatedEventFailure: null,
            };
        case eventManagerTypes.CREATE_EVENT_SUCCESS:
            return {
                ...state,
                isCreatingEvent: false,
                isCreatedEventSuccess: action.payload,
                isCreatedEventFailure: null,
            };
        case eventManagerTypes.CREATE_EVENT_FAILURE:
            return {
                ...state,
                isCreatingEvent: false,
                isCreatedEventSuccess: null,
                isCreatedEventFailure: action.payload,
            };

        case eventManagerTypes.GET_SINGLE_EVENT_REQUEST:
            return {
                ...state,
                isFetchingSingleEvent: true,
                isFetchedSingleEventSuccess: null,
                isFetchedSingleEventFailure: null,
            };
        case eventManagerTypes.GET_SINGLE_EVENT_SUCCESS:
            return {
                ...state,
                isFetchingSingleEvent: false,
                isFetchedSingleEventSuccess: action.payload,
                isFetchedSingleEventFailure: null,
            };
        case eventManagerTypes.GET_SINGLE_EVENT_FAILURE:
            return {
                ...state,
                isFetchingSingleEvent: false,
                isFetchedSingleEventSuccess: null,
                isFetchedSingleEventFailure: action.payload,
            };

        case eventManagerTypes.GET_EVENT_VENDORS_REQUEST:
            return {
                ...state,
                isFetchingEventVendors: true,
                isFetchedEventVendorsSuccess: null,
                isFetchedEventVendorsFailure: null,
            };
        case eventManagerTypes.GET_EVENT_VENDORS_SUCCESS:
            return {
                ...state,
                isFetchingEventVendors: false,
                isFetchedEventVendorsSuccess: action.payload,
                isFetchedEventVendorsFailure: null,
            };
        case eventManagerTypes.GET_EVENT_VENDORS_FAILURE:
            return {
                ...state,
                isFetchingEventVendors: false,
                isFetchedEventVendorsSuccess: null,
                isFetchedEventVendorsFailure: action.payload,
            };

        case eventManagerTypes.GET_EVENTS_REQUEST:
            return {
                ...state,
                isFetchingEvents: true,
                isFetchedEventsSuccess: null,
                isFetchedEventsFailure: null,
            };
        case eventManagerTypes.GET_EVENTS_SUCCESS:
            return {
                ...state,
                isFetchingEvents: false,
                isFetchedEventsSuccess: action.payload,
                isFetchedEventsFailure: null,
            };
        case eventManagerTypes.GET_EVENTS_FAILURE:
            return {
                ...state,
                isFetchingEvents: false,
                isFetchedEventsSuccess: null,
                isFetchedEventsFailure: action.payload,
            };

        case eventManagerTypes.GET_ORGANIZERS_REQUEST:
            return {
                ...state,
                isFetchingOrganizers: true,
                isFetchedOrganizersSuccess: null,
                isFetchedOrganizersFailure: null,
            };
        case eventManagerTypes.GET_ORGANIZERS_SUCCESS:
            return {
                ...state,
                isFetchingOrganizers: false,
                isFetchedOrganizersSuccess: action.payload,
                isFetchedOrganizersFailure: null,
            };
        case eventManagerTypes.GET_ORGANIZERS_FAILURE:
            return {
                ...state,
                isFetchingOrganizers: false,
                isFetchedOrganizersSuccess: null,
                isFetchedOrganizersFailure: action.payload,
            };

        default:
            return state;
    }
}
